// extracted by mini-css-extract-plugin
module.exports = {"root":"CarouselProfileCard_root__25jzY","cardWrapper":"CarouselProfileCard_cardWrapper__2W-bk","userName":"CarouselProfileCard_userName__X08st"};